import React from 'react';
import {FilterSelect} from './FilterSelect';
import {FilterControlWithNegate} from './FilterControlWithNegate';
import {
  ActiveCountryCodes,
  CountryCode,
  CountryList,
} from '../../../shared/countries';

const options = ActiveCountryCodes.map((code) => ({
  value: code,
  label: CountryList[code],
}));

export const CountryFilterControl = ({
  value,
  negate,
  onChange,
  onRemove,
}: {
  value: CountryCode[];
  negate?: boolean;
  onChange: (value: CountryCode[], negate?: boolean) => void;
  onRemove: () => void;
}) => {
  return (
    <FilterControlWithNegate
      value={value}
      negate={negate}
      onChange={onChange}
      onRemove={onRemove}
    >
      {(_, onValueChange) => (
        <FilterSelect
          options={options}
          isMulti
          onChange={(values) => {
            onValueChange(values.map((v) => v.value));
          }}
          value={value.map((v) => ({
            value: v,
            label: CountryList[v],
          }))}
        />
      )}
    </FilterControlWithNegate>
  );
};
